// src/MainScreen.js
import React, { useState, useEffect } from "react";
import ChatBox from "./ChatBox";
import FileUpload from "./FileUpload";
import "./MainScreen.css";

function MainScreen({
  messages,
  onSendMessage,
  theme,
  fileUploaded,     // mevcut prop'unu koruyoruz
  onFileUpload,     // mevcut prop'unu koruyoruz (ör. parent'ta state tetiklemek için)
  loading,
  resetToken,
  resetConvIdTrigger // Yeni: App.js'den gelen tetikleyici
}) {
  // backend'in döndürdüğü conv_id'yi burada tutuyoruz
  const [convId, setConvId] = useState(null);

  // Yeni sohbet tetiklenince convId sıfırlansın
  useEffect(() => {
    setConvId(null);
  }, [resetToken]);

  const handleUploadSuccess = (id) => {
    setConvId(id);           // ChatBox için gerekli
    onFileUpload?.(id);      // Mevcut parent akışın da bilgilensin (geri uyum)
  };

  const hasPdf = Boolean(convId) || Boolean(fileUploaded);

  return (
    <div className={`main-screen ${theme}`}>
      {loading ? (
        <div className="chat-section">
          <div className="upload-loading-alert">📄 PDF yükleniyor, lütfen bekleyin...</div>
        </div>
      ) : !hasPdf ? (
        <div className="upload-section">
          <div className="main-title">PDF dosyanızı yükleyin ve konuşmaya başlayın.</div>
          {/* FileUpload artık onUploadSuccess ile conv_id veriyor */}
          <FileUpload onUploadSuccess={handleUploadSuccess} theme={theme} />
        </div>
      ) : (
        <div className="chat-section">
          <div className="upload-success-alert">📎 PDF başarıyla yüklendi.</div>

          {/* Mevcut props'larını koruyorum + yeni conv_id prop'u ekliyorum */}
          <ChatBox
            conv_id={convId}
            messages={messages}
            onSendMessage={onSendMessage}
            theme={theme}
          />
        </div>
      )}
    </div>
  );
}

export default MainScreen;
